import Text from "@afa-shared/afa-components/dist/Text";
import { ContentLink } from "@components/Link/ContentLink";
import Grid from "@components/client/Grid";
import Icon from "@components/client/Icon";

import pageInfoStyles from "./PageInformation.module.scss";

interface IPageInformation {
  pageId?: string;
  pageUpdateDate?: string;
  authorName?: string;
  reviewName?: string;
  reviewRole?: string;
}

export const PageInformation = ({
  pageId,
  pageUpdateDate,
  authorName,
  reviewName,
  reviewRole,
}: IPageInformation) => {
  const hasAuthorInfo = Boolean(authorName);
  const reviewerName = reviewName;
  const reviewerDetails = [reviewerName, reviewRole].filter(Boolean).join(", ");
  const hasReviewerInfo = Boolean(reviewerDetails);

  return (
    <Grid className={pageInfoStyles.pageInformationWrapper}>
      {(pageUpdateDate || hasAuthorInfo || hasReviewerInfo) && (
        <div className={pageInfoStyles.pageInformationDatesWrapper}>
          {pageUpdateDate && (
            <div
              className={pageInfoStyles.wrapper}
              data-contentful-entry-id={pageId}
              data-contentful-field-id="pageUpdateDate"
            >
              <Text variant="span" weight="bold" className={pageInfoStyles.pageInfoText}>
                <strong>Senast uppdaterad</strong>
              </Text>
              <Text variant="span" className={pageInfoStyles.pageInfoText}>
                {pageUpdateDate}
              </Text>
            </div>
          )}
          {hasReviewerInfo && (
            <div
              className={pageInfoStyles.wrapper}
              data-contentful-entry-id={pageId}
              data-contentful-field-id="reviewName"
            >
              <Text variant="span" weight="bold" className={pageInfoStyles.pageInfoText}>
                <strong>Granskad av</strong>
              </Text>
              <Text variant="span" className={pageInfoStyles.pageInfoText}>
                {reviewerDetails}
              </Text>
            </div>
          )}
          {hasAuthorInfo && (
            <div
              className={pageInfoStyles.wrapper}
              data-contentful-entry-id={pageId}
              data-contentful-field-id="authorName"
            >
              <Text variant="span" weight="bold" className={pageInfoStyles.pageInfoText}>
                <strong>Skriven av</strong>
              </Text>
              <Text variant="span" className={pageInfoStyles.pageInfoText}>
                {authorName}
              </Text>
            </div>
          )}
        </div>
      )}

      <ContentLink
        href="/om-webbplatsen/hur-vi-uppdaterar-vart-innehall"
        className={pageInfoStyles.reviewLink}
        trackingData={{
          sectionTitle: undefined,
          sectionBlockIndex: undefined,
        }}
        contentText="Så skriver och granskar vi texterna"
      >
        <Icon name="arrow_forward" size="sm" referenceSize="link" className={pageInfoStyles.icon} />
        Så skriver och granskar vi texterna
      </ContentLink>
    </Grid>
  );
};
export default PageInformation;
